import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/ADD_INVOICE';
export const {action: show} = createAction(`${domain}/SHOW`, (institutionId, billPayerId, inferredChildId) => ({
    institutionId,
    billPayerId,
    inferredChildId,
}));

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {
    action: previewInvoice,
    success: previewInvoiceSuccess,
    failed: previewInvoiceFailed,
    aborted: previewInvoiceAborted,
} = createAction(`${domain}/PREVIEW_INVOICE`, (institutionId, billPayerId, invoice, currentMonths, initialFetch) => ({
    institutionId,
    billPayerId,
    invoice,
    currentMonths,
    initialFetch,
}));

export const {action: storeInvoicePreviewId} = createAction(`${domain}/STORE_INVOICE_PREVIEW_ID`, requestId => ({
    requestId,
}));

export const {action: previewLoaded} = createAction(`${domain}/PREVIEW_LOADED`, requestId => ({requestId}));

export const {action: showDetails} = createAction(`${domain}/SHOW_DETAILS`, show => ({show}));
